// API utility functions for making HTTP requests

/**
 * Make a GET request
 * @param {string} url - API endpoint URL
 * @returns {Promise} - Response data
 */
export const get = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'GET',
      credentials: 'include', // Include cookies for session
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Something went wrong');
    }
    
    return data;
  } catch (error) {
    console.error('GET request error:', error);
    throw error;
  }
};

/**
 * Make a POST request
 * @param {string} url - API endpoint URL
 * @param {object} body - Request body
 * @returns {Promise} - Response data
 */
export const post = async (url, body) => {
  try {
    const response = await fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Something went wrong');
    }
    
    return data;
  } catch (error) {
    console.error('POST request error:', error);
    throw error;
  }
};

/**
 * Make a PUT request
 * @param {string} url - API endpoint URL
 * @param {object} body - Request body
 * @returns {Promise} - Response data
 */
export const put = async (url, body) => {
  try {
    const response = await fetch(url, {
      method: 'PUT',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Something went wrong');
    }
    
    return data;
  } catch (error) {
    console.error('PUT request error:', error);
    throw error;
  }
};

/**
 * Make a DELETE request
 * @param {string} url - API endpoint URL
 * @returns {Promise} - Response data
 */
export const del = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    
    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Something went wrong');
    }
    
    return data;
  } catch (error) {
    console.error('DELETE request error:', error);
    throw error;
  }
};

const api = { get, post, put, del };

export default api;
